import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ReactComponent as RadioOn } from '../../assets/images/svg/radio-on.svg';
import { ReactComponent as RadioOff } from '../../assets/images/svg/radio-off.svg';
import { formatAddressStringInline } from '../../util/helpers/addressHelper';
import { variables } from '../../assets/styles/variables';
import themeColors from '../../assets/styles/themeColors';
import {
  uButtonClear,
  uFullWidth,
  uOutlineNone,
} from '../../assets/styles/utility';
import { mediaBelow, pxToRem, pxToRemMd } from '../../assets/styles/helper';
// import Paragraph from '../Paragraph/Paragraph';
// import { ReactComponent as AlertTriangle } from '../../assets/images/svg/alert-triangle.svg';
import addressTagType, {
  ADDRESS_TAG_TYPES,
  ADDRESS_TAG_TYPES_ICONS,
} from '../../util/enum/api/addressTagType';
import Paragraph from '../Paragraph/Paragraph';

export const DeliveryAddressContainer = styled.li`
  display: flex;
  flex-direction: column;
  border: 1px solid transparent;
  border-radius: ${variables.borderRadius.borderRadius};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
  background-color: ${themeColors.colorBackgroundSecondary};
  position: relative;

  ${(props) =>
    props.isSelected && `border-color: ${themeColors.colorTextSecondary}`};
`;

export const DeliveryAddressButton = styled.button`
  ${uButtonClear};
  ${uOutlineNone};
  display: flex;
  align-items: center;
  cursor: pointer;
  ${uFullWidth};
  padding: ${pxToRem(10)} ${pxToRem(12)};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  min-height: 52px;
`;

export const DeliveryAddressIndicator = styled.span`
  width: 16px;
  margin-right: ${pxToRem(10)};
`;

export const DeliveryAddressValue = styled.p`
  display: flex;
  align-items: center;
  font-size: ${pxToRem(14)};
  line-height: 1.75;
  text-align: left;
  color: ${themeColors.colorTextPrimary};
  font-weight: 500;

  span {
    font-size: ${pxToRem(12)};
    font-weight: 400;
    color: ${themeColors.colorTextSecondary};
    display: block;
  }
`;

const DeliveryAddressIcon = styled.div`
  width: ${pxToRem(32)};
  height: ${pxToRem(32)};
  background-color: ${themeColors.colorGrey};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${pxToRem(6)};
  border-radius: ${variables.borderRadius.borderRadius};

  ${mediaBelow(variables.breakpoints.bpMd)} {
    width: ${pxToRemMd(28)};
    height: ${pxToRemMd(28)};
  }
`;

const CurrentAddressFlag = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  background-color: ${themeColors.colorTextSecondary};
  color: ${themeColors.colorWhite};
  display: inline-flex;
  padding: 2px 6px;
  justify-content: center;
  align-items: center;
  font-size: ${pxToRem(14)};
  font-weight: 500;
  border-radius: 0 3px 0 2px;
`;

const DeliveryAddress = ({ address, isSelected, onClick, countries }) => {
  const isDisabled = address?.IsPoBox;

  return (
    <>
      <DeliveryAddressContainer
        isSelected={isSelected}
        key={address?.AddressUid}
        disabled={isDisabled}
      >
        {address?.IsDefaultMailingAddress && (
          <CurrentAddressFlag>Current</CurrentAddressFlag>
        )}
        <DeliveryAddressButton
          type="button"
          onClick={() => !isDisabled && onClick(address)}
          disabled={isDisabled}
        >
          <DeliveryAddressIndicator>
            {isSelected ? <RadioOn /> : <RadioOff />}
          </DeliveryAddressIndicator>
          <DeliveryAddressValue>
            {address?.TagType && (
              <DeliveryAddressIcon>
                {ADDRESS_TAG_TYPES_ICONS[address?.TagType]}
              </DeliveryAddressIcon>
            )}
            <div>
              {address?.TagType && (
                <Paragraph fontSize={14}>
                  {address?.TagType === ADDRESS_TAG_TYPES.OTHER
                    ? address?.TagNote
                    : addressTagType[address?.TagType]}
                </Paragraph>
              )}

              <span>{formatAddressStringInline(address, countries)}</span>
            </div>
            {/* //{' '} */}
            {/* {isDisabled && (
            //   <WarningNote
            //     fontSize={16}
            //     color={themeColors.colorTextSecondary}
            //     bold
            //   >
            //     <AlertTriangle />
            //     {t('buyWizard.buyForDelivery.chooseDeliveryAddress.poBox')}
            //   </WarningNote>
            // )} */}
          </DeliveryAddressValue>
        </DeliveryAddressButton>
      </DeliveryAddressContainer>
    </>
  );
};

DeliveryAddress.propTypes = {
  address: PropTypes.shape({
    AddressLine: PropTypes.string,
    City: PropTypes.string,
    StateRegion: PropTypes.string,
    PostalCode: PropTypes.string,
    AddressUid: PropTypes.string,
    AddressLine2: PropTypes.string,
    CountryIso3Code: PropTypes.string,
    IsPoBox: PropTypes.bool,
    TagType: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    TagNote: PropTypes.string,
    IsDefaultMailingAddress: PropTypes.bool,
  }),
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
  countries: PropTypes.arrayOf(PropTypes.shape({})),
};

export default DeliveryAddress;
